import { useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { css } from "@emotion/react";
import { BeatLoader } from "react-spinners";
import { TiContacts } from "react-icons/ti";
import { LuSettings2 } from "react-icons/lu";
import { toast } from "react-toastify";
import "./styles.css";

import { PageHeader } from "../../../page-header";
import { Contato } from "../../../contato";
import { useTed } from '../../../../hooks/useTed';
import { getAvatarChar, getBankName } from "../../../../utils/formatter";
import { useAuth } from "../../../../hooks/useAuth";
import { companyUserPermissions } from "../../../../enums/companyUserPermissions";
import { userHasPermission } from "../../../../utils/verifyUserPermission";

const PaginaTed = () => {
  const navigate = useNavigate()

  const {
    favorites,
    fetchFavorites,
    favoritesLoader,
    setAgencia,
    setConta,
    setDigito,
    setTipoConta,
    setCpf,
    setNome,
    setBanco,
    setAlreadyFavorites,
  } = useTed()

  const { user } = useAuth();

  function handleToTransfer(data) {
    setAgencia(data.bankBranch)
    setConta(data.bankAccount)
    setDigito(data.bankAccountDigit)
    setTipoConta(data.accountType)
    setCpf(data.taxNumber)
    setNome(data.name)
    setBanco(data.bank)
    setAlreadyFavorites(true),

    navigate('/pagina-transferencia')
  }

  function clearInputsTransfer() {
    setAgencia("")
    setConta("")
    setDigito("")
    setTipoConta(0)
    setCpf("")
    setNome("")
    setBanco("")
    setAlreadyFavorites(false)
  }

  useEffect(() => {
    fetchFavorites()
  }, [])

  const override = css`
    display: flex;
    margin: 0 auto;
    border-color: red;
  `;

  useEffect(() => {
    if (!(user && Object.keys(user).length > 0)) return;

    if(!userHasPermission(user, companyUserPermissions.SEND_TED)) {
      toast.error('Você não tem permissão para acessar esta funcionalidade.');
      navigate('/pagina-pix');
    }
  }, [user]);

  return (
    <div className="pagina-ted-container">
      <div className="pagina-ted-header">
        <PageHeader title="TED" pages={[{ name: 'TED', link: "" }]} />
      </div>

      <div className="pagina-ted-content">
        <div className="pagina-ted-content-actions">
          <button disabled title="Em Breve" className="btn-contatos-disabled">
            <TiContacts size={16} />
            Contatos
          </button>

          <NavLink
            onClick={clearInputsTransfer}
            to="/pagina-transferencia"
            className="content-actions-button-red"
          >
            Nova Transferência TED
          </NavLink>

          <NavLink 
            to={!userHasPermission(user, companyUserPermissions.VIEW_TED_LIMITS) ? "#" : "/limites-ted"} 
            className={!userHasPermission(user, companyUserPermissions.VIEW_TED_LIMITS) ? "btn-contatos-disabled" : "btn-contatos"}
            title={!userHasPermission(user, companyUserPermissions.VIEW_TED_LIMITS) ? "Você não tem permissão para acessar essa funcionalidade" : ""}
          >
            <LuSettings2 size={16} />
            Meus Limites Ted
          </NavLink>
        </div>

        <div className="ted-contatos-container">
          <span>Contatos Recentes</span>

          <div className="ted-contatos-list">
            {
              favoritesLoader
              ? (
                <BeatLoader
                  color={"var(--secondary-color)"}
                  loading={favoritesLoader}
                  css={override}
                  size={20}
                />
              ) : (
                <>
                  {
                    favorites.length
                    ? (
                      <>
                        {favorites.map((item, index) => (
                          <button
                            key={index}
                            onClick={() => handleToTransfer(item)}
                          >
                            <Contato
                              avatar={item.name ? getAvatarChar(item.name) : ''}
                              name={item.name}
                              bank={getBankName(item.bank)}
                            />
                          </button>
                        ))}
                      </>
                    ) : (
                      <span>Sem contatos favoritos.</span>
                    )
                  }
                </>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaginaTed;
